/**
 * EG Card Quantity Select
 * - Shows a clean label in the closed select (e.g. "1 Tray")
 * - Keeps priced labels in the dropdown menu options (e.g. "1 Tray ($11.99/Tray)")
 *
 * Works for any <select class="eg-card-qty-select"> rendered in product cards.
 */

(() => {
  const SELECTOR = 'select.eg-card-qty-select';
  const INIT_ATTR = 'data-eg-card-qty-init';

  function ensureOptionData(selectEl) {
    if (!selectEl || selectEl.nodeName !== 'SELECT') return;
    if (selectEl.hasAttribute(INIT_ATTR)) return;

    for (const opt of selectEl.options) {
      if (!opt.dataset.menu) opt.dataset.menu = (opt.textContent || '').trim();

      if (!opt.dataset.display) {
        const menu = opt.dataset.menu || '';
        const idx = menu.indexOf('(');
        opt.dataset.display = (idx !== -1 ? menu.slice(0, idx).trim() : menu.trim());
      }
    }

    selectEl.setAttribute(INIT_ATTR, 'true');
  }

  function setMenuLabels(selectEl) {
    ensureOptionData(selectEl);
    for (const opt of selectEl.options) {
      if (opt.dataset.menu) opt.textContent = opt.dataset.menu;
    }
  }

  function setCollapsedLabel(selectEl) {
    ensureOptionData(selectEl);

    // Restore all menu labels first (so only the selected option gets shortened).
    setMenuLabels(selectEl);

    const selectedOpt = selectEl.selectedOptions?.[0] || selectEl.options[selectEl.selectedIndex];
    if (!selectedOpt) return;

    if (selectedOpt.dataset.display) selectedOpt.textContent = selectedOpt.dataset.display;
  }

  function initAllExisting() {
    document.querySelectorAll(SELECTOR).forEach((selectEl) => setCollapsedLabel(selectEl));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllExisting);
  } else {
    initAllExisting();
  }

  // Ensure priced labels are present right before the dropdown opens.
  document.addEventListener(
    'pointerdown',
    (e) => {
      const selectEl = e.target?.closest?.(SELECTOR);
      if (!selectEl) return;
      setMenuLabels(selectEl);
    },
    true
  );

  // Keyboard open (Space/Enter/ArrowDown)
  document.addEventListener(
    'keydown',
    (e) => {
      const target = e.target;
      if (!target || !target.matches?.(SELECTOR)) return;
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'ArrowDown') setMenuLabels(target);
    },
    true
  );

  // After a selection, collapse back to the clean label.
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (!target || !target.matches?.(SELECTOR)) return;
    setCollapsedLabel(target);
  });

  // If user cancels/blur, collapse back to the clean label.
  document.addEventListener(
    'blur',
    (e) => {
      const target = e.target;
      if (!target || !target.matches?.(SELECTOR)) return;
      setCollapsedLabel(target);
    },
    true
  );

  // Theme editor: re-init when a section reloads.
  document.addEventListener('shopify:section:load', initAllExisting);
})();

